
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.667 2.667H12V1.333h-1.333v1.334H5.333V1.333H4v1.334h-.667C2.6 2.667 2 3.267 2 4v9.333c0 .734.6 1.334 1.333 1.334h9.334c.733 0 1.333-.6 1.333-1.334V4c0-.733-.6-1.333-1.333-1.333zm0 10.666H3.333V6.667h9.334v6.666zm-9.334-8V4h9.334v1.333H3.333zm3.707 6.974l3.953-3.954-.706-.706-3.247 3.246-1.407-1.406-.706.706 2.113 2.114z","fill":"currentColor"}})])
          )
        }
      }
    